import { useMemo } from 'react'

import { ManualTask } from 'Automations/watchtower/inbox/manualTasks/types'

import { notificationDefinitions } from '../notificationDefinitions'

export const NotificationItem = ({
  manualTask,
  isSelected,
  hideUnreadIndicator,
  onClick
}: {
  manualTask: ManualTask
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => {
  const ListItem = useMemo(() => {
    return notificationDefinitions[manualTask.type]?.listItemContent
  }, [manualTask])

  if (!ListItem) {
    return null
  }

  return (
    <ListItem
      taskId={manualTask.id}
      isSelected={isSelected}
      hideUnreadIndicator={hideUnreadIndicator}
      onClick={onClick}
    />
  )
}
